import styled, { keyframes } from 'styled-components'
import { Button } from '@components/Button'

export const StyledButton = styled(Button)`
  background: ${({ theme }) => theme.colors.menuBg} !important;
  color: ${({ theme }) => theme.colors.neutralWhite} !important;
  gap: ${({ theme }) => theme.spacing.md}rem !important;

  .monetary {
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSize.sm}rem;
    font-variant-numeric: tabular-nums;
  }
`

export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}rem;
`

export const ShortcutLabel = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  line-height: 1;
  gap: 2px;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
`

export const ShortcutLabelLine = styled.span<{ $size: string; $opacity?: number }>`
  font-size: ${({ theme, $size }) => theme.fontSize[$size]}rem;
  opacity: ${({ $opacity }) => ($opacity !== undefined ? $opacity : 1)};
`

export const MenuButton = styled(Button)`
  width: 100%;
`

export const DropdownButton = styled(StyledButton)`
  padding-left: ${({ theme }) => theme.spacing.sm}rem !important;
  padding-right: ${({ theme }) => theme.spacing.sm}rem !important;
`

export const ImageIcon = styled.img<{ $isMain?: boolean }>`
  background: ${({ $isMain, theme }) => ($isMain ? theme.colors.neutralWhite : 'transparent')};
  border-radius: ${({ $isMain }) => ($isMain ? '999px' : '0.25rem')};
  padding: ${({ $isMain }) => ($isMain ? '0.3rem' : '0')};
  object-fit: contain;
`

export const StyledHolviSvg = styled.svg<{ $variant: 'light' | 'dark' }>`
  width: ${({ theme }) => theme.iconSize.md}rem;
  height: ${({ theme }) => theme.iconSize.md}rem;
  flex-shrink: 0;

  .holvi-fill {
    fill: ${({ theme, $variant }) =>
      $variant === 'light' ? theme.colors.neutralWhite : theme.colors.iconGrayDark};
  }
`

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`

export const Shimmer = styled.div`
  height: 1em;
  width: 6rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm}rem;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.15) 25%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0.15) 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.2s ease-in-out infinite;
`
